// extracted by mini-css-extract-plugin
module.exports = {"container":"use-case-tabs_container__UcKeF","tabList":"use-case-tabs_tabList__Hxas9","panel":"use-case-tabs_panel__GorMR","content":"use-case-tabs_content__iL3UF"};